// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1456":"225f8dbd","4699":"68f2eb07","9066":"dc112a36"}[chunkId] || chunkId) + "." + {"1456":"ed81f1cec1ab90b7","4699":"a5d3f9f28169390a","5704":"b511f21af2062416","8884":"3272bd073beee73a","9066":"f05ff3686e3b9e31"}[chunkId] + ".js";
};